import { render, staticRenderFns } from "./Leaderboard.vue?vue&type=template&id=c05c6aa4"
import script from "./Leaderboard.vue?vue&type=script&lang=js"
export * from "./Leaderboard.vue?vue&type=script&lang=js"
import style0 from "./Leaderboard.vue?vue&type=style&index=0&id=c05c6aa4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports